module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAXCAYAAAAYyi9XAAABTUlEQVRIiaWWzW3CQBCFH1Hu0EHcQegAJM4odBCX4A6gBB85ugTSgamAlBB3gCsgGmsRZjx/m4zky+6383Zm1rM7226O+KMtAXxnLB34l4wFDYArgFv6LgB2Dv/D+DIqWAH4BDBn47XDv7HxQ0SwIFCZO+XyEcFGiOxuUoS1xXuCVKOVMveVajS2NYAPhT8T7wlqNYKSzsbghzlL8CAU/W694LyK8JrgIjkwd8t47aBgnA1NsDIKLwmGeUmQjvXeWNyxDuNlg/jWErRSA+GwWL/BhOeCReoQljX/4CeCXnQ8nWUm/yS4cJoxWHq82nF+IuidNO4gwrd8gAta1jMHXjp7K8Iyc7el0VUkfiLoRQe2Wy86U5Cu/vcMB4Vxg4QEI9F1o6sowlP9xPcOCYo7YTZeHHk4qT5fUyegf4o+ckYPJTKKiF+wZLn8wwD8AgAfUYiFMcVjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1